// WP-0.7 (§18.1): Lucide icons, 20px default. Names come from the route table as strings;
// this resolves them to components. Unknown names fall back to a dot so the shell never
// crashes on a typo.
import { Circle, icons } from 'lucide-react';

export function Icon({
  name,
  size = 20,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}): React.JSX.Element {
  const LucideIcon = (icons as Record<string, typeof Circle>)[name] ?? Circle;
  return <LucideIcon size={size} {...(className !== undefined ? { className } : {})} />;
}
